/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import styles from './Meditations.module.css';
import { ReactComponent as Close } from '../ico/close.svg';
import { ReactComponent as DeleteIco } from '../ico/delete.svg';
import { Button } from '../../UI/Button/Button';
import { observer } from 'mobx-react';
import { useStores } from '../../../hooks/useStore';
import { useApi } from '../../../hooks/useApi';
import { Input } from '../../UI/input/input';
import { useEffect, useState } from 'react';
import { MeditationsModel } from '../../../models/meditations';
import { TextArea } from '../../UI/TextArea/TextArea';
import cn from 'classnames';
import { AppSettings } from '../../../appSettings';

interface PopupProps {
  item: MeditationsModel | null;
  onClose: () => void;
  update: () => void;
}

const MeditationPopUP: React.FC<PopupProps> = observer(
  ({ item, onClose, update }) => {
    const store = useStores();
    const api = useApi();

    const [name, setName] = useState<string>('');
    const [description, setDescription] = useState<string>('');
    const [fullDescription, setFullDescription] = useState<string>('');
    const [image, setImage] = useState<string | null>(null);
    const [url, setUrl] = useState<string>('');
    const [groupId, setGroupId] = useState<string>('');
    const [category, setCategory] = useState<string>('');

    const [imageFile, setImageFile] = useState<File | null>(null);

    const [disable, setDisable] = useState<boolean>(true);

    useEffect(() => {
      if (item) {
        setName(item?.name ?? '');
        setDescription(item.description ?? '');
        setFullDescription(item.full_description ?? '');
        setUrl(item.url ?? '');
        setGroupId(item.group_id ?? '');
        setImage(AppSettings.api.url + item.image);
        setCategory(item.category ?? '');
      }
    }, [item]);

    useEffect(() => {
      if (
        name !== '' &&
        description !== '' &&
        fullDescription !== null &&
        url !== '' &&
        groupId !== ''
      ) {
        setDisable(false);
      } else {
        setDisable(true);
      }
    }, [name, description, fullDescription, url, groupId]);

    // const handleOverlayClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    // 	// Проверяем, что клик произошел именно на overlay, а не на его содержимое
    // 	if (event.target === event.currentTarget) {
    // 		onClose();
    // 	}
    // };

    const handleButtonClick = async () => {
      try {
        store.notificationsStore.showPreloader();

        const formData = new FormData();

        formData.append('name', name);
        formData.append('description', description);
        formData.append('full_description', fullDescription);
        formData.append('url', url);
        formData.append('group_id', groupId);

        if (category !== '') {
          formData.append('category', category);
        }

        if (imageFile) {
          formData.append('image', imageFile);
        }

        if (item) {
          await api.meditations.update(formData, item.id as string);
        } else {
          await api.meditations.create(formData);
        }

        update();
        onClose();

        store.notificationsStore.setNotifications('Успешно выполнено');
      } catch (e) {
        store.notificationsStore.setError('Ошибка при выполнении');
      } finally {
        store.notificationsStore.hidePreloader();
      }
    };

    const setFreeGroup = () => {
      setGroupId('free');
    };

    const deleteItem = async () => {
      try {
        store.notificationsStore.showPreloader();
        await api.meditations.delete(item?.id as string);
        store.notificationsStore.setNotifications('Успешно удалено');
        update();
        onClose();
      } catch (e) {
        store.notificationsStore.setError('Ошибка при удалении');
      } finally {
        store.notificationsStore.hidePreloader();
      }
    };

    const prewPhoto = (file: File) => {
      if (image) {
        URL.revokeObjectURL(image);
      }
      setImage(URL.createObjectURL(file));
    };

    const [showApproveDelete, setShowApproveDelete] = useState<boolean>(false);

    return (
      <>
        <div
          className={styles.container}
          // onClick={handleOverlayClick}
        >
          <div className={styles.form}>
            <Close className={styles.close} onClick={onClose} />
            <h3>{!item ? 'Добавление' : 'Изменение'} медитации</h3>
            <div className={styles.line} style={{ marginBottom: 20 }} />

            <div
              style={{ maxWidth: '90%', height: 'auto', minHeight: 150 }}
              className={cn(styles.imageArea, { [styles.imageSet]: image })}
            >
              <input
                type="file"
                name="file"
                id="file"
                className={styles.inputfile}
                accept="image/jpeg,image/png"
                onChange={(e) => {
                  if (e.target.files && e.target.files[0]) {
                    prewPhoto(e.target.files[0]);
                    setImageFile(e.target.files[0]);
                  }
                }}
              />
              {!image && (
                <label htmlFor="file" className={styles.labelImage}>
                  <p>Нажмите, чтобы выбрать фото</p>
                </label>
              )}
              {image && (
                <>
                  <div
                    className={styles.deleteImage}
                    onClick={() => {
                      setImage(null);
                    }}
                  >
                    <DeleteIco />
                  </div>
                  <img src={image} alt="Фото" width="100%" height="100%" />
                </>
              )}
            </div>

            <Input
              style={{ maxWidth: '90%' }}
              value={name}
              placeholder="Название"
              textLabel="Название"
              onChange={(event) => setName(event.target.value)}
            />

            <Input
              style={{ maxWidth: '90%' }}
              value={description}
              placeholder="Описание"
              textLabel="Описание"
              onChange={(event) => setDescription(event.target.value)}
            />

            <TextArea
              maxWidth={'90%'}
              value={fullDescription}
              placeholder="Полное описание"
              textLabel="Полное описание"
              onChange={(event) => setFullDescription(event.target.value)}
            />

            <Input
              style={{ maxWidth: '90%' }}
              value={url}
              placeholder="Ссылка на аудио"
              textLabel="Ссылка на аудио"
              onChange={(event) => setUrl(event.target.value)}
            />

            <Input
              style={{ maxWidth: '90%' }}
              value={category}
              placeholder="Категория"
              textLabel="Категория"
              onChange={(event) => setCategory(event.target.value)}
            />

            <div style={{ display: 'flex', maxWidth: '90%', width: '90%' }}>
              <Input
                style={{ maxWidth: '90%' }}
                value={groupId}
                placeholder="ID группы"
                textLabel="ID группы"
                onChange={(event) => setGroupId(event.target.value)}
              />
              <Button
                onClick={setFreeGroup}
                appearance="link"
                style={{ maxWidth: 150, marginLeft: 10 }}
              >
                Бесплатно
              </Button>
            </div>

            <div className={styles.line} style={{ marginBottom: 10 }} />

            <div
              style={{
                display: 'flex',
                width: '90%',
                justifyContent: 'center',
              }}
            >
              {!showApproveDelete && (
                <Button
                  disabled={disable}
                  onClick={handleButtonClick}
                  style={{ margin: 5, maxWidth: 320, marginBottom: 25 }}
                  appearance="auth"
                >
                  {!item ? 'Создать' : 'Изменить'}
                </Button>
              )}
              {item && !showApproveDelete && (
                <Button
                  onClick={() => setShowApproveDelete(true)}
                  style={{ margin: 5, maxWidth: 320, marginBottom: 25 }}
                  appearance="link"
                >
                  Удалить
                </Button>
              )}

              {showApproveDelete && (
                <div
                  style={{
                    display: 'flex',
                    width: '90%',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <p style={{ marginBottom: 10 }}>Точно хотите удалить?</p>
                  <div
                    style={{
                      display: 'flex',
                      width: '90%',
                      justifyContent: 'center',
                    }}
                  >
                    <Button
                      disabled={disable}
                      onClick={deleteItem}
                      style={{ margin: 5, maxWidth: 320, marginBottom: 25 }}
                      appearance="link"
                    >
                      Удалить
                    </Button>
                    <Button
                      disabled={disable}
                      onClick={() => setShowApproveDelete(false)}
                      style={{ margin: 5, maxWidth: 320, marginBottom: 25 }}
                      appearance="auth"
                    >
                      Отмена
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  },
);

export default MeditationPopUP;
